"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RadioButtonSelected = props => {
  const {
    height,
    width
  } = props;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "svg",
    fill: _constants.colours.activeState,
    preserveAspectRatio: "xMidYMid meet",
    height: height,
    width: width,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "radioOutline" // half of 50 to get its centre
    ,
    cx: "25",
    cy: "25" // adjust lower if 25 overflows the bound
    ,
    r: "23",
    fill: _constants.colours.activeState,
    stroke: _constants.colours.activeState,
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: "radioDot" // same thing as above
    ,
    cx: "25",
    cy: "25" // adjust for the size of the inner dot
    ,
    r: "10",
    fill: _constants.colours.white
  }));
};

RadioButtonSelected.defaultProps = {
  height: 24,
  width: 24
};
var _default = RadioButtonSelected;
exports.default = _default;